import { render, staticRenderFns } from "./SummaInput.vue?vue&type=template&id=64682eaa"
import script from "./SummaInput.vue?vue&type=script&lang=js"
export * from "./SummaInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports